export default "__VITE_ASSET__CjgRaZvI__"